// @flow

export const PageElementCacheControllerMiddleware = storeApi => next => action => {
    if (action.type === "enhanced/page/load") {
        //TODO: check if any page needs to be unloaded and if so which one
    }

    next(action); //original action will be forwarded either way
};
